<template>
  <div class="main-container">
    <breadcrumb :list="breadcrumbList" />
    <tl-header type="h1">
      <div class="main-header">FBP Claims</div>
    </tl-header>
    <div class="permission-alert-msg" v-show="!(ifAdmin || ifHr)">
      You have only view permission.
    </div>
     <toast-message
      message="No Data Found"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
      />
    <div class="row" :disabled="!(ifAdmin || ifHr)">

      <!-- <div class="col-4">
        <tl-select
          name="month"
          id="month"
          label="Month *"
          labelText="name"
          :options="monthsData"
          v-model="formData.monthObj"
          v-validate="'required'"
          :classname="errors.has('month')"
          :errormsg="errors.first('month')"
          @change="
            (val) => {
              formData.monthObj = val;
              resetForm();
            }
          "
        ></tl-select>
      </div> -->
      </div>
<!--     
    <br />
    <div class="col-4 margin-top-10">
        <search-dropdown
          v-if="!showEmpDetails"
          placeholder="Search Employee"
          :employeeData="employeeData"
          :clearRequired="true"
          @getList="searchEmployeesByName($event)"
          @empselected="(emp) => selectedEmp(emp)"
        />
      </div>
      
      <div class="col-4">
        <selected-employee-card
            v-if="showEmpDetails"
            :empName="data.first_name"
            :empId="data.code"
            :empMail="data.email_id"
            @click="close"
        >
        </selected-employee-card>
      </div>
      <br /> -->
      
     <div class="col-4">
        <tl-select
          name="ListRequest"
          id="ListRequest"
          label="List Request"
          labelText="name"
          :options="listRequestArray"
          v-model="formData.listRequestObj"
          v-validate="'required'"
          :classname="errors.has('ListRequest')"
          :errormsg="errors.first('ListRequest')"
          @change="
            (val) => {
              formData.listRequestObj = val;
              fetchData();
            }
          "
        />
      </div>

    <div class="margin-top-20" ref="table_div" @scroll="onScroll()"
      v-if="fbpClaimsData.length>0">
      <!-- <button @click="sortBy">Sort By E-Code</button> -->
      <data-table
        :columns="fbpClaimsColumnNames"
        :tableData="fbpClaimsData"
        :checkbox="false"
        :withForm="false"
        :showinrow="true"
        :showhistory="false"
        :showdelete="false"
        :showedit="false"
      >
        <template v-slot:rowcontent="slotprops">
          <p
            v-if="
              slotprops.value.column.key != 'name' &&
              slotprops.value.column.key != 'component' &&
              slotprops.value.column.key != 'bill_date' && 
              slotprops.value.column.key != 'for_month' &&
              slotprops.value.column.key != 'status' && 
              slotprops.value.column.key != 'amount_claimed' && 
              slotprops.value.column.key != 'amount_approved' &&
              slotprops.value.column.key != 'remark'
            "
          >
            {{ slotprops.value.record[slotprops.value.column.key] }}
          </p>
          <div v-if="slotprops.value.column.key == 'ecode'">
            <span>{{ slotprops.value.record.Employee.code }}</span>
          </div>
          <div v-if="slotprops.value.column.key == 'name'">
            <span
              >{{ slotprops.value.record.Employee.first_name }}
              {{ slotprops.value.record.Employee.last_name }}</span
            >
          </div>
          <div v-if="slotprops.value.column.key == 'component'">
            <p v-for="(item, i) of slotprops.value.record.details" :key="i">
              {{ item }}
            </p>
          </div>
          <div v-if="slotprops.value.column.key == 'bill_date'">
            {{ formatDate(slotprops.value.record.bill_date) }}
          </div>
          <div class="text-capitals" v-if="slotprops.value.column.key == 'amount_claimed'">
            <span>{{ formateLess.format(slotprops.value.record.amount_claimed) }}</span>
          </div>
          <div class="text-capital" v-if="slotprops.value.column.key == 'for_month'">
            <span>{{ slotprops.value.record.for_month }}</span>
          </div>
          <div class="text-capitals" v-if="slotprops.value.column.key == 'amount_approved'">
            <span>{{ formateLess.format(slotprops.value.record.amount_approved) }}</span>
          </div>
          <div class="text-capital" v-if="slotprops.value.column.key == 'status'">
            <span>{{ slotprops.value.record.status }}</span>
          </div>
            <div class="text-capital" v-if="slotprops.value.column.key == 'remark'">
            <span>{{ slotprops.value.record.remark }}</span>
          </div>
          <p v-if="slotprops.value.column.key == 'edit'">
            <img
                src="@/assets/edit.svg"
                class="cross-circle-img"
                
                @click="editPermission(slotprops.value.record)"
                alt="actionIcon"
                style="margin:0px 10px;"
                />
          </p>
          
        </template>
      </data-table>
    </div>

    <bottom-action-container class="placeEnd">
      <template slot="end">
        <btn-grp>
          <btn text="Back" type="secondary" @click="back" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import selectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";



export default {
  name: "ApproveFbpClaims",
  components: {
    SearchDropdown,
    selectedEmployeeCard,
  },
  data() {
    return {
      formate: "",
      formateLess:"",
      yearEnd:"",
      year:"",
      changeListRequest: "",
      monthSelected: "",
      listRequestLabel: "",
      employeeName: "",
      showEmpDetails: false,
      employee_id: "",
      tempArray: [],
      employeeList:[],
      employeeData: [],
      fbpClaimsData: [],
      toast: false,
      monthsData: [
        
      ],
      yearsData: ["2022", "2021", "2020", "2019"],
      listRequestArray: [
        { name: "Approved", val: "approved" },
        { name: "Partially Approved", val: "part_approved" },
        { name: "Pending", val: "pending" },
        { name: "Rejected", val: "reject" },
      ],
      fbpClaimsColumnNames: [
        {
          label: "Employee Code",
          key: "ecode",
        },
        {
          label: "Name",
          key: "name",
        },
        {
          label: "Component",
          key: "component",
        },
        {
          label: "Date",
          key: "bill_date",
        },
        {
          label: "Month",
          key: "for_month",
        },
        {
          label: "Requested Amount(₹)",
          key: "amount_claimed",
          style: "text-align:right"
        },
        {
          label: "Approved Amount(₹)",
          key: "amount_approved",
          style: "text-align:right"
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remark",
          key: "remark",
        },
        {
          label: "",
          key: "edit"
        }
      ],
      formData: {
        monthObj: "",
        yearsObj: "",
        e_code: "",
        listRequestObj: "pending",
      },
      employeeDetails: {},
      breadcrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`,
        },
        {
          name: "FBP",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll`,
        },
        {
          name: "Approve/View Approved Claims",
          url: "",
        },
      ],
    };
  },

  mounted() {
    this.getOrgLeIdList();
    this.employeeData = [];
    this.reset();
    this.getFinancialYear();
    this.emp_id = null;
    // this.fetchDataOnLoad()
    
  },
  activated() {
    //this.fetchDataOnLoad()
    this.getOrgLeIdList();
    //this.reset();
    // this.fetchDataOnLoad();
    this.getFinancialYear();
    this.page = 1;
    this.employeeData = [];
    this.emp_id = null;
  },

  computed: {
    ...mapState({
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear
    }),

    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },

    ...mapState("onboard/organization", {
      orgIds: (state) => state.id,
    }),

    ifTeamleaderAnchorPermission() {
      if (
        this.role === "TEAMLEADER" ||
        this.role === "ANCHOR" ||
        this.role === "ADMIN"
      ) {
        if (this.companyValue) {
          return true;
        } else {
          return false;
        }
      }
    },
    ifAdmin() {
      return localStorage.getItem("userRole") == "ADMIN" ? true : false;
    },
    ifHr() {
      return localStorage.getItem("userRole") == "HR" ? true : false;
    },
  },

  methods: {
    ...mapActions({
      fetch_claims: "dashboard/payroll/utilities/approveFbpClaims/fetchAll",
      act_changeEditMode:
        "dashboard/payroll/utilities/approveFbpClaims/changeEditMode",
    }),

    ...mapActions({
      fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
      fetchEmployeeDocumentsByEmployeeId:
        "dashboard/organisation/employeeDocument/fetchEmployeeByID",
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    sortBy() {
      this.fbpClaimsData.sort((a, b) => {
        return a.ecode - b.ecode;
      });
    },

    async searchEmployeesByName(val) {
      try {
        let res = await this.fetchEmployeeByLeAndName({
          le_id: this.le_id,
          key: val,
        });
        this.employeeData = res.data.payload;
        ////console.log("resss",res.data.payload[0].id);
        this.emp_id = res.data.payload[0].id;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async selectedEmp(emp) {
      try {
        this.employeeDocs = [];
        ////console.log("empObj", emp);
        this.data = emp;
        // //console.log("inside selected employe",emp)
        this.emp_id = emp.id;
        this.showEmpDetails = true;
        if(this.formData.listRequestObj){
          this.fetchData();
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    close() {
      this.emp_id = null;
      this.showEmpDetails = false;
      this.fetchData();
    },

    onScroll() {
      let bottomOfWindow =
        this.$refs.table_div.scrollHeight - this.$refs.table_div.scrollTop <=
        this.$refs.table_div.offsetHeight;
      if (bottomOfWindow && this.fbpClaimsData.length < this.totalEmployees) {
        this.page += 1;
        this.fetchemp();
      }
    },

    resetForm() {
      this.formData.listRequestObj = "";
    },

    reset(){
      this.formData.listRequestObj = "";
      this.formData.monthObj = null;
      this.fbpClaimsData =[];
      this.showEmpDetails =false;
    },

    getFinancialYear(){
      let month = this.payrollMonth;
      if(month == "January" ||month == "February" || month=="March"){
          this.yearEnd = Number(this.payrollYear);
          this.year = Number(this.payrollYear)-1;
      }else {
          this.yearEnd = Number(this.payrollYear) + 1;
          this.year = Number(this.payrollYear);
      }
      this.monthsData =[
        {name:`April-${this.year}`, val:"apr"},
        {name:`May-${this.year}`, val:"may"},
        {name:`June-${this.year}`, val:"jun"},
        {name:`July-${this.year}`, val:"jul"},
        {name:`August-${this.year}`, val:"aug"},
        {name:`September-${this.year}`, val:"sep"},
        {name:`October-${this.year}`, val:"oct"},
        {name:`November-${this.year}`, val:"nov"},
        {name:`December-${this.year}`, val:"dec"},
        {name:`January-${this.yearEnd}`, val:"jan"},
        {name:`February-${this.yearEnd}`, val:"feb"},
        {name:`March-${this.yearEnd}`, val:"mar"},
      ]
    },

    async fetchData() {
      try {
        this.fbpClaimsData = [];
        let data = {
          status: this.formData.listRequestObj.val,
        };
        //console.log(this.employeeName, "LINE NO 339");
        if (this.emp_id) {
          data.employee_id = this.emp_id;
          let res = await this.fetch_claims(data);
          this.fbpClaimsData = res.data.payload;
          if(res.data.payload.length>0){
            this.toast = false
          }else{
            this.toast = true
          }
          //console.log(res.data.payload, "line no 288");
        } else {
          data.legal_entity_id = this.le_id;
          let res = await this.fetch_claims(data);
          this.fbpClaimsData = res.data.payload;
          if(res.data.payload.length>0){
            this.toast = false
          }else{
            this.toast = true
          }
          //console.log(res, "line no 291");
        }
      } catch (error) {
        this.toast = true;
        //console.log(error);
      }
    },

    async fetchDataOnLoad() {
      try {
        this.fbpClaimsData = [];
        let data = {
          status: "pending",
        };
          data.legal_entity_id = this.le_id;
          let res = await this.fetch_claims(data);
          this.fbpClaimsData = res.data.payload;
          if(res.data.payload.length>0){
            this.toast = false
          }else{
            this.toast = false
          }  
      } catch (error) {
        this.toast = true;
      }
    },

    async editPermission(record) {
      try {
        await this.act_changeEditMode({
          editMode: true,
          record: record,
        });
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/editFbpClaims`,
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    },


    back() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll`
      });
    },

    async getOrgLeIdList() {
      const org = this.orgId;
      const le = this.le_id;
      //console.log("Org:", org);
      //console.log("Le ID", le);
      let bodyParams = {};
      let data = await this.getOrgLeList({
        data: {
          ...bodyParams,
        },
      });
      //{org_id:this.orgId, le_id:this.le_id}
      this.role = data.data.user.userRole;
      this.companyValue = data.data.user.permissions.company ? true : false;
      //console.log("PL-3406", data);
      this. formate= new Intl.NumberFormat('en-in',{
        currency: "INR",
        style: "currency"
          });
       this.formateLess= new Intl.NumberFormat('en-in');
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/dashboard/content/_section.scss"; // Content Section

.component-wrapper {
  margin-left: 14px;
  margin-top: 10px;
}

.main-header {
  color: #6d6d6d;
  margin-top: 37px;
  font-size: 16px;
}

.margin-top-20 {
  margin-top: 20px;
}

.margin-top-10{
  margin-top: 10px;
}

.nav {
  color: #555555;
  font-size: 11px;
}

.filters {
  display: grid;
  grid-gap: 10px;
  grid-template: auto / repeat(4, minmax(200px, 1fr));
}

.text{
  color: #842029;
}
.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  border-color: #f5c2c7;
}
.sm-img {
  width: 35%;
}

.text-capital {
  text-transform: capitalize;
}
.text-capitals{
  text-transform: capitalize;
  text-align: right;
}

.resettle-btn {
  border: #5d409f solid 1px;
  color: #5d409f;
}
</style>
